module.exports = __webpack_public_path__ + "static/media/playIcon.4b30e3db.svg";